// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  mapName: __t.string().name("map_name"),
  phase: __t.string(),
  tick: __t.u32(),
  hostPlayerId: __t.string().name("host_player_id"),
  victoryCounter: __t.u32().name("victory_counter"),
  winner: __t.option(__t.u32()),
  createdAt: __t.timestamp().name("created_at"),
  armyBudget: __t.u32().name("army_budget"),
  maxArmySize: __t.u32().name("max_army_size"),
  mode: __t.option(__t.string()),
  ruleset: __t.option(__t.string()),
  season: __t.option(__t.string()),
  startTickOffset: __t.u32().name("start_tick_offset"),
});
